import { forwardRef } from 'react'
import { ButtonLinkProps } from './props'
import { Text } from '../../Atoms'
import { StyledButtonLink } from './styles'

const ButtonLink = forwardRef<HTMLButtonElement, ButtonLinkProps>(
    ({ icon, inline, subTitle, title, truncate, ...props }, ref) => (
        <StyledButtonLink {...props} ref={ref} inline={inline}>
            {icon}
            <Text bold>{title}</Text>
            {!inline && (
                <Text
                    css={{
                        textAlign: 'start',
                        ...(truncate && { maxW: '100%' }),
                    }}
                    ellipsis={truncate}
                    size="s"
                >
                    {subTitle}
                </Text>
            )}
        </StyledButtonLink>
    )
)

ButtonLink.displayName = 'ButtonLink'

export default ButtonLink

export { StyledButtonLink }
